import { SortOption } from '../interfaces/sort-option.interface';
import { SellSort } from 'remarketing-angular-library';
import { Injectable } from '@angular/core';
import { TranslocoService } from '@jsverse/transloco';
import { take } from 'rxjs/operators';

@Injectable({
  providedIn: 'root'
})
export class SellSortOptions {
  sellSortOptionsHeadersTranslations = {
    STATUS: '',
    OFFERS: '',
    QUESTIONS: '',
    MAKE_AND_MODEL: '',
    MODEL_YEAR: '',
    DAYS_REMAINING: '',
    OPENING_CURRENT_PRICE: '',
    TENANT_BADGE: '',
    GROUP_LOCATION: '',
    STOCK_NUMBER: '',
    HITS: '',
    BUY_NOW_PRICE: '',
    AVERAGE_SALES_PRICE: '',
    AVERAGE_BOOK_VALUE: '',
    SOLD_DATE: '',
    BUYER_NAME: '',
    SALE_PRICE: '',
    FEES: '',
    DAYS_ON_HOLD: '',
    POSTED_DATE: '',
    REMOVED_DATE: '',
    STATUS_CHANGED_DATE: ''
  };

  sellSortOptionsTranslations = {
    HIGHEST: '',
    LOWEST: '',
    MOST: '',
    LEAST: '',
    NEWEST: '',
    OLDEST: '',
    A_Z: '',
    Z_A: '',
    LATEST: '',
    EARLIEST: ''
  };

  constructor(private readonly translocoService: TranslocoService) {}

  getTranslations() {
    this.translocoService
      .selectTranslateObject('UIComponents.sellSortOptionsHeadersTranslations')
      .pipe(take(1))
      .subscribe(translate => {
        this.sellSortOptionsHeadersTranslations.STATUS = translate.status;
        this.sellSortOptionsHeadersTranslations.OFFERS = translate.offers;
        this.sellSortOptionsHeadersTranslations.QUESTIONS = translate.questions;
        this.sellSortOptionsHeadersTranslations.MAKE_AND_MODEL = translate.makeAndModel;
        this.sellSortOptionsHeadersTranslations.MODEL_YEAR = translate.modelYear;
        this.sellSortOptionsHeadersTranslations.DAYS_REMAINING = translate.daysRemaining;
        this.sellSortOptionsHeadersTranslations.OPENING_CURRENT_PRICE = translate.openingCurrentPrice;
        this.sellSortOptionsHeadersTranslations.TENANT_BADGE = translate.tenantBadge;
        this.sellSortOptionsHeadersTranslations.GROUP_LOCATION = translate.groupLocation;
        this.sellSortOptionsHeadersTranslations.STOCK_NUMBER = translate.stockNumber;
        this.sellSortOptionsHeadersTranslations.HITS = translate.hits;
        this.sellSortOptionsHeadersTranslations.BUY_NOW_PRICE = translate.buyNowPrice;
        this.sellSortOptionsHeadersTranslations.AVERAGE_SALES_PRICE = translate.averageSalesPrice;
        this.sellSortOptionsHeadersTranslations.AVERAGE_BOOK_VALUE = translate.averageBookValue;
        this.sellSortOptionsHeadersTranslations.SOLD_DATE = translate.soldDate;
        this.sellSortOptionsHeadersTranslations.BUYER_NAME = translate.buyerName;
        this.sellSortOptionsHeadersTranslations.SALE_PRICE = translate.salePrice;
        this.sellSortOptionsHeadersTranslations.FEES = translate.fees;
        this.sellSortOptionsHeadersTranslations.DAYS_ON_HOLD = translate.daysOnHold;
        this.sellSortOptionsHeadersTranslations.POSTED_DATE = translate.postedDate;
        this.sellSortOptionsHeadersTranslations.REMOVED_DATE = translate.removedDate;
        this.sellSortOptionsHeadersTranslations.STATUS_CHANGED_DATE = translate.statusChangedDate;
      });

    this.translocoService
      .selectTranslateObject('UIComponents.sellSortOptionsTranslations')
      .pipe(take(1))
      .subscribe(translate => {
        this.sellSortOptionsTranslations.HIGHEST = translate.highest;
        this.sellSortOptionsTranslations.LOWEST = translate.lowest;
        this.sellSortOptionsTranslations.MOST = translate.most;
        this.sellSortOptionsTranslations.LEAST = translate.least;
        this.sellSortOptionsTranslations.NEWEST = translate.newest;
        this.sellSortOptionsTranslations.OLDEST = translate.oldest;
        this.sellSortOptionsTranslations.A_Z = translate.a_z;
        this.sellSortOptionsTranslations.Z_A = translate.z_a;
        this.sellSortOptionsTranslations.LATEST = translate.latest;
        this.sellSortOptionsTranslations.EARLIEST = translate.earliest;
      });
  }

  active(): SortOption[] {
    this.getTranslations();
    return [
      { options: [{ name: this.sellSortOptionsHeadersTranslations.STATUS, value: SellSort.STATUS, selected: true }] },
      {
        header: this.sellSortOptionsHeadersTranslations.OFFERS,
        options: [
          { name: this.sellSortOptionsTranslations.MOST, value: SellSort.OFFER_COUNT__DESC, selected: false },
          { name: this.sellSortOptionsTranslations.LEAST, value: SellSort.OFFER_COUNT__ASC, selected: false }
        ]
      },
      {
        header: this.sellSortOptionsHeadersTranslations.QUESTIONS,
        options: [
          { name: this.sellSortOptionsTranslations.MOST, value: SellSort.QUESTION_COUNT__DESC, selected: false },
          { name: this.sellSortOptionsTranslations.LEAST, value: SellSort.QUESTION_COUNT__ASC, selected: false }
        ]
      },
      {
        header: this.sellSortOptionsHeadersTranslations.MAKE_AND_MODEL,
        options: [
          { name: this.sellSortOptionsTranslations.A_Z, value: SellSort.MAKE_MODEL__ASC, selected: false },
          { name: this.sellSortOptionsTranslations.Z_A, value: SellSort.MAKE_MODEL__DESC, selected: false }
        ]
      },
      {
        header: this.sellSortOptionsHeadersTranslations.MODEL_YEAR,
        options: [
          { name: this.sellSortOptionsTranslations.NEWEST, value: SellSort.MODEL_YEAR__DESC, selected: false },
          { name: this.sellSortOptionsTranslations.OLDEST, value: SellSort.MODEL_YEAR__ASC, selected: false }
        ]
      },
      {
        header: this.sellSortOptionsHeadersTranslations.DAYS_REMAINING,
        options: [
          { name: this.sellSortOptionsTranslations.LEAST, value: SellSort.DAYS_REMAINING__ASC, selected: false },
          { name: this.sellSortOptionsTranslations.MOST, value: SellSort.DAYS_REMAINING__DESC, selected: false }
        ]
      },
      {
        header: this.sellSortOptionsHeadersTranslations.OPENING_CURRENT_PRICE,
        options: [
          { name: this.sellSortOptionsTranslations.LOWEST, value: SellSort.OPENING_PRICE__ASC, selected: false },
          { name: this.sellSortOptionsTranslations.HIGHEST, value: SellSort.OPENING_PRICE__DESC, selected: false }
        ]
      },
      {
        header: this.sellSortOptionsHeadersTranslations.TENANT_BADGE,
        options: [
          { name: this.sellSortOptionsTranslations.A_Z, value: SellSort.TENANT_BADGE__ASC, selected: false },
          { name: this.sellSortOptionsTranslations.Z_A, value: SellSort.TENANT_BADGE__DESC, selected: false }
        ],
        requiresSellTenantBadge: true
      },
      {
        header: this.sellSortOptionsHeadersTranslations.GROUP_LOCATION,
        options: [
          { name: this.sellSortOptionsTranslations.A_Z, value: SellSort.GROUP_LOCATION__ASC, selected: false },
          { name: this.sellSortOptionsTranslations.Z_A, value: SellSort.GROUP_LOCATION__DESC, selected: false }
        ],
        requiresLeadSeller: true
      },
      {
        header: this.sellSortOptionsHeadersTranslations.STOCK_NUMBER,
        options: [
          { name: this.sellSortOptionsTranslations.A_Z, value: SellSort.STOCK_NUMBER__ASC, selected: false },
          { name: this.sellSortOptionsTranslations.Z_A, value: SellSort.STOCK_NUMBER__DESC, selected: false }
        ],
        requiresSellUpdateInventory: true
      },
      {
        header: this.sellSortOptionsHeadersTranslations.HITS,
        options: [
          { name: this.sellSortOptionsTranslations.LEAST, value: SellSort.HITS__ASC, selected: false },
          { name: this.sellSortOptionsTranslations.MOST, value: SellSort.HITS__DESC, selected: false }
        ],
        requiresSellUpdateInventory: true
      },
      {
        header: this.sellSortOptionsHeadersTranslations.BUY_NOW_PRICE,
        options: [
          { name: this.sellSortOptionsTranslations.LOWEST, value: SellSort.BUY_NOW_AMOUNT__ASC, selected: false },
          { name: this.sellSortOptionsTranslations.HIGHEST, value: SellSort.BUY_NOW_AMOUNT__DESC, selected: false }
        ],
        requiresSellUpdateInventory: true
      },
      {
        header: this.sellSortOptionsHeadersTranslations.AVERAGE_SALES_PRICE,
        options: [
          { name: this.sellSortOptionsTranslations.LOWEST, value: SellSort.AVERAGE_SALES_PRICE__ASC, selected: false },
          { name: this.sellSortOptionsTranslations.HIGHEST, value: SellSort.AVERAGE_SALES_PRICE__DESC, selected: false }
        ],
        requiresSellUpdateInventory: true
      },
      {
        header: this.sellSortOptionsHeadersTranslations.AVERAGE_BOOK_VALUE,
        options: [
          { name: this.sellSortOptionsTranslations.LOWEST, value: SellSort.AVERAGE_BOOK_VALUE__ASC, selected: false },
          { name: this.sellSortOptionsTranslations.HIGHEST, value: SellSort.AVERAGE_BOOK_VALUE__DESC, selected: false }
        ],
        requiresSellUpdateInventory: true
      }
    ];
  }
  sold(): SortOption[] {
    this.getTranslations();
    return [
      {
        header: this.sellSortOptionsHeadersTranslations.SOLD_DATE,
        options: [
          { name: this.sellSortOptionsTranslations.LATEST, value: SellSort.SOLD_DATE__DESC, selected: false },
          { name: this.sellSortOptionsTranslations.EARLIEST, value: SellSort.SOLD_DATE__ASC, selected: false }
        ]
      },
      {
        header: this.sellSortOptionsHeadersTranslations.BUYER_NAME,
        options: [
          { name: this.sellSortOptionsTranslations.A_Z, value: SellSort.BUYING_DEALER_NAME__ASC, selected: false },
          { name: this.sellSortOptionsTranslations.Z_A, value: SellSort.BUYING_DEALER_NAME__DESC, selected: false }
        ]
      },
      {
        header: this.sellSortOptionsHeadersTranslations.MAKE_AND_MODEL,
        options: [
          { name: this.sellSortOptionsTranslations.A_Z, value: SellSort.MAKE_MODEL__ASC, selected: false },
          { name: this.sellSortOptionsTranslations.Z_A, value: SellSort.MAKE_MODEL__DESC, selected: false }
        ]
      },
      {
        header: this.sellSortOptionsHeadersTranslations.MODEL_YEAR,
        options: [
          { name: this.sellSortOptionsTranslations.NEWEST, value: SellSort.MODEL_YEAR__DESC, selected: false },
          { name: this.sellSortOptionsTranslations.OLDEST, value: SellSort.MODEL_YEAR__ASC, selected: false }
        ]
      },
      {
        header: this.sellSortOptionsHeadersTranslations.SALE_PRICE,
        options: [
          { name: this.sellSortOptionsTranslations.LOWEST, value: SellSort.SALE_PRICE__ASC, selected: false },
          { name: this.sellSortOptionsTranslations.HIGHEST, value: SellSort.SALE_PRICE__DESC, selected: false }
        ]
      },
      {
        header: this.sellSortOptionsHeadersTranslations.TENANT_BADGE,
        options: [
          { name: this.sellSortOptionsTranslations.A_Z, value: SellSort.TENANT_BADGE__ASC, selected: false },
          { name: this.sellSortOptionsTranslations.Z_A, value: SellSort.TENANT_BADGE__DESC, selected: false }
        ],
        requiresSellTenantBadge: true
      },
      {
        header: this.sellSortOptionsHeadersTranslations.GROUP_LOCATION,
        options: [
          { name: this.sellSortOptionsTranslations.A_Z, value: SellSort.GROUP_LOCATION__ASC, selected: false },
          { name: this.sellSortOptionsTranslations.Z_A, value: SellSort.GROUP_LOCATION__DESC, selected: false }
        ],
        requiresLeadSeller: true
      },
      {
        header: this.sellSortOptionsHeadersTranslations.STOCK_NUMBER,
        options: [
          { name: this.sellSortOptionsTranslations.A_Z, value: SellSort.STOCK_NUMBER__ASC, selected: false },
          { name: this.sellSortOptionsTranslations.Z_A, value: SellSort.STOCK_NUMBER__DESC, selected: false }
        ],
        requiresSellUpdateInventory: true
      },
      {
        header: this.sellSortOptionsHeadersTranslations.HITS,
        options: [
          { name: this.sellSortOptionsTranslations.LEAST, value: SellSort.HITS__ASC, selected: false },
          { name: this.sellSortOptionsTranslations.MOST, value: SellSort.HITS__DESC, selected: false }
        ],
        requiresSellUpdateInventory: true
      },
      {
        header: this.sellSortOptionsHeadersTranslations.FEES,
        options: [
          { name: this.sellSortOptionsTranslations.LOWEST, value: SellSort.FEES__ASC, selected: false },
          { name: this.sellSortOptionsTranslations.HIGHEST, value: SellSort.FEES__DESC, selected: false }
        ],
        requiresSellUpdateInventory: true
      }
    ];
  }
  leadSeller(): SortOption[] {
    this.getTranslations();
    return [
      {
        header: this.sellSortOptionsHeadersTranslations.GROUP_LOCATION,
        options: [
          { name: this.sellSortOptionsTranslations.A_Z, value: SellSort.GROUP_LOCATION__ASC, selected: false },
          { name: this.sellSortOptionsTranslations.Z_A, value: SellSort.GROUP_LOCATION__DESC, selected: false }
        ]
      }
    ];
  }
  hold(): SortOption[] {
    this.getTranslations();
    return [
      {
        header: this.sellSortOptionsHeadersTranslations.MAKE_AND_MODEL,
        options: [
          { name: this.sellSortOptionsTranslations.A_Z, value: SellSort.MAKE_MODEL__ASC, selected: false },
          { name: this.sellSortOptionsTranslations.Z_A, value: SellSort.MAKE_MODEL__DESC, selected: false }
        ]
      },
      {
        header: this.sellSortOptionsHeadersTranslations.MODEL_YEAR,
        options: [
          { name: this.sellSortOptionsTranslations.NEWEST, value: SellSort.MODEL_YEAR__DESC, selected: false },
          { name: this.sellSortOptionsTranslations.OLDEST, value: SellSort.MODEL_YEAR__ASC, selected: false }
        ]
      },
      {
        header: this.sellSortOptionsHeadersTranslations.STOCK_NUMBER,
        options: [
          { name: this.sellSortOptionsTranslations.A_Z, value: SellSort.STOCK_NUMBER__ASC, selected: false },
          { name: this.sellSortOptionsTranslations.Z_A, value: SellSort.STOCK_NUMBER__DESC, selected: false }
        ]
      },
      {
        header: this.sellSortOptionsHeadersTranslations.OPENING_CURRENT_PRICE,
        options: [
          { name: this.sellSortOptionsTranslations.LOWEST, value: SellSort.OPENING_PRICE__ASC, selected: false },
          { name: this.sellSortOptionsTranslations.HIGHEST, value: SellSort.OPENING_PRICE__DESC, selected: false }
        ]
      },
      {
        header: this.sellSortOptionsHeadersTranslations.BUY_NOW_PRICE,
        options: [
          { name: this.sellSortOptionsTranslations.LOWEST, value: SellSort.BUY_NOW_AMOUNT__ASC, selected: false },
          { name: this.sellSortOptionsTranslations.HIGHEST, value: SellSort.BUY_NOW_AMOUNT__DESC, selected: false }
        ]
      },
      {
        header: this.sellSortOptionsHeadersTranslations.DAYS_ON_HOLD,
        options: [
          { name: this.sellSortOptionsTranslations.LOWEST, value: SellSort.HOLD_DAYS__ASC, selected: false },
          { name: this.sellSortOptionsTranslations.HIGHEST, value: SellSort.HOLD_DAYS__DESC, selected: false }
        ]
      },
      {
        header: this.sellSortOptionsHeadersTranslations.HITS,
        options: [
          { name: this.sellSortOptionsTranslations.LEAST, value: SellSort.HITS__ASC, selected: false },
          { name: this.sellSortOptionsTranslations.MOST, value: SellSort.HITS__DESC, selected: false }
        ]
      }
    ];
  }
  all(): SortOption[] {
    this.getTranslations();
    return [
      {
        header: this.sellSortOptionsHeadersTranslations.STATUS,
        options: [
          { name: this.sellSortOptionsTranslations.A_Z, value: SellSort.STATUS__ASC, selected: false },
          { name: this.sellSortOptionsTranslations.Z_A, value: SellSort.STATUS__DESC, selected: false }
        ]
      },
      {
        header: this.sellSortOptionsHeadersTranslations.STATUS_CHANGED_DATE,
        options: [
          { name: this.sellSortOptionsTranslations.NEWEST, value: SellSort.STATUS_CHANGED_DATE__DESC, selected: true },
          { name: this.sellSortOptionsTranslations.OLDEST, value: SellSort.STATUS_CHANGED_DATE__ASC, selected: true }
        ]
      },
      {
        header: this.sellSortOptionsHeadersTranslations.MAKE_AND_MODEL,
        options: [
          { name: this.sellSortOptionsTranslations.A_Z, value: SellSort.MAKE_MODEL__ASC, selected: false },
          { name: this.sellSortOptionsTranslations.Z_A, value: SellSort.MAKE_MODEL__DESC, selected: false }
        ]
      },
      {
        header: this.sellSortOptionsHeadersTranslations.MODEL_YEAR,
        options: [
          { name: this.sellSortOptionsTranslations.NEWEST, value: SellSort.MODEL_YEAR__DESC, selected: false },
          { name: this.sellSortOptionsTranslations.OLDEST, value: SellSort.MODEL_YEAR__ASC, selected: false }
        ]
      },
      {
        header: this.sellSortOptionsHeadersTranslations.STOCK_NUMBER,
        options: [
          { name: this.sellSortOptionsTranslations.A_Z, value: SellSort.STOCK_NUMBER__ASC, selected: false },
          { name: this.sellSortOptionsTranslations.Z_A, value: SellSort.STOCK_NUMBER__DESC, selected: false }
        ]
      },
      {
        header: this.sellSortOptionsHeadersTranslations.OPENING_CURRENT_PRICE,
        options: [
          { name: this.sellSortOptionsTranslations.LOWEST, value: SellSort.OPENING_PRICE__ASC, selected: false },
          { name: this.sellSortOptionsTranslations.HIGHEST, value: SellSort.OPENING_PRICE__DESC, selected: false }
        ]
      },
      {
        header: this.sellSortOptionsHeadersTranslations.BUY_NOW_PRICE,
        options: [
          { name: this.sellSortOptionsTranslations.LOWEST, value: SellSort.BUY_NOW_AMOUNT__ASC, selected: false },
          { name: this.sellSortOptionsTranslations.HIGHEST, value: SellSort.BUY_NOW_AMOUNT__DESC, selected: false }
        ]
      },
      {
        header: this.sellSortOptionsHeadersTranslations.AVERAGE_SALES_PRICE,
        options: [
          { name: this.sellSortOptionsTranslations.LOWEST, value: SellSort.AVERAGE_SALES_PRICE__ASC, selected: false },
          { name: this.sellSortOptionsTranslations.HIGHEST, value: SellSort.AVERAGE_SALES_PRICE__DESC, selected: false }
        ]
      },
      {
        header: this.sellSortOptionsHeadersTranslations.AVERAGE_BOOK_VALUE,
        options: [
          { name: this.sellSortOptionsTranslations.LOWEST, value: SellSort.AVERAGE_BOOK_VALUE__ASC, selected: false },
          { name: this.sellSortOptionsTranslations.HIGHEST, value: SellSort.AVERAGE_BOOK_VALUE__DESC, selected: false }
        ]
      },
      {
        header: this.sellSortOptionsHeadersTranslations.HITS,
        options: [
          { name: this.sellSortOptionsTranslations.LEAST, value: SellSort.HITS__ASC, selected: false },
          { name: this.sellSortOptionsTranslations.MOST, value: SellSort.HITS__DESC, selected: false }
        ]
      }
    ];
  }
  removed(): SortOption[] {
    this.getTranslations();
    return [
      {
        header: this.sellSortOptionsHeadersTranslations.MAKE_AND_MODEL,
        options: [
          { name: this.sellSortOptionsTranslations.A_Z, value: SellSort.MAKE_MODEL__ASC, selected: false },
          { name: this.sellSortOptionsTranslations.Z_A, value: SellSort.MAKE_MODEL__DESC, selected: false }
        ]
      },
      {
        header: this.sellSortOptionsHeadersTranslations.MODEL_YEAR,
        options: [
          { name: this.sellSortOptionsTranslations.NEWEST, value: SellSort.MODEL_YEAR__DESC, selected: false },
          { name: this.sellSortOptionsTranslations.OLDEST, value: SellSort.MODEL_YEAR__ASC, selected: false }
        ]
      },
      {
        header: this.sellSortOptionsHeadersTranslations.STOCK_NUMBER,
        options: [
          { name: this.sellSortOptionsTranslations.A_Z, value: SellSort.STOCK_NUMBER__ASC, selected: false },
          { name: this.sellSortOptionsTranslations.Z_A, value: SellSort.STOCK_NUMBER__DESC, selected: false }
        ]
      },
      {
        header: this.sellSortOptionsHeadersTranslations.OPENING_CURRENT_PRICE,
        options: [
          { name: this.sellSortOptionsTranslations.LOWEST, value: SellSort.OPENING_PRICE__ASC, selected: false },
          { name: this.sellSortOptionsTranslations.HIGHEST, value: SellSort.OPENING_PRICE__DESC, selected: false }
        ]
      },
      {
        header: this.sellSortOptionsHeadersTranslations.POSTED_DATE,
        options: [
          { name: this.sellSortOptionsTranslations.NEWEST, value: SellSort.POSTED_DATE__DESC, selected: false },
          { name: this.sellSortOptionsTranslations.OLDEST, value: SellSort.POSTED_DATE__ASC, selected: false }
        ]
      },
      {
        header: this.sellSortOptionsHeadersTranslations.REMOVED_DATE,
        options: [
          { name: this.sellSortOptionsTranslations.NEWEST, value: SellSort.STATUS_CHANGED_DATE__DESC, selected: false },
          { name: this.sellSortOptionsTranslations.OLDEST, value: SellSort.STATUS_CHANGED_DATE__ASC, selected: false }
        ]
      },
      {
        header: this.sellSortOptionsHeadersTranslations.FEES,
        options: [
          { name: this.sellSortOptionsTranslations.LOWEST, value: SellSort.FEES__ASC, selected: false },
          { name: this.sellSortOptionsTranslations.HIGHEST, value: SellSort.FEES__DESC, selected: false }
        ]
      },
      {
        header: this.sellSortOptionsHeadersTranslations.HITS,
        options: [
          { name: this.sellSortOptionsTranslations.LEAST, value: SellSort.HITS__ASC, selected: false },
          { name: this.sellSortOptionsTranslations.MOST, value: SellSort.HITS__DESC, selected: false }
        ]
      }
    ];
  }
}
